import React from "react";

const Sidebar = ({ activeSection, setActiveSection, toggleSidebar }) => {
    const handleClick = (section) => {
        setActiveSection(section);
        if (window.innerWidth < 768) {
            toggleSidebar();
        }
    };

    return (
        <div className="sidebar show">
            <h3>Navigation</h3>
            <button onClick={() => handleClick("HeadMetaConfigEditor")}>Head Meta Config</button>
            <button onClick={() => handleClick("categories")}>Categories</button>
            <button onClick={() => handleClick("products")}>Products</button>
            <button onClick={() => handleClick("cardConfig")}>Card Config</button>
            <button onClick={() => handleClick("homeConfig")}>Home Config</button>
            <button onClick={() => handleClick("aboutUsConfig")}>About Us Config</button>
            <button onClick={() => handleClick("floatingIconsConfig")}>Floating Icons Config</button>
            <button onClick={() => handleClick("navbarConfig")}>Navbar Config</button>
            <button onClick={() => handleClick("footerConfig")}>Footer Config</button>
            <button onClick={() => handleClick("ProductDescriptionConfigEditor")}>Description Config</button>
        </div>
    );
};

export default Sidebar;
